export default __webpack_public_path__ + "static/media/Clasp of the Steel Behemoth.6b7fc14c.jpg";